export { LawFirms as default } from '@/screens/home/LawFirms'
